import { useQuery, UseQueryResult } from "react-query";
import { fetchBase } from "./base";

export interface EnvConfig {
  appName: string;
  orgName: string;
  appRootUrl: string;
  appV2RootUrl: string;
  colorBackgroundDark: string;
  logoHorizontalDark: string;
  logoFavicon: string;
  privacyPolicyUrl: string;
  termsOfServiceUrl: string;
  cdnRootUrl: string;
  installerPackageNameWindows: string;
  installerPackageNameMacOS: string;
  disabledInstallers: string[];
}

const getEnvConfig = (): Promise<EnvConfig> =>
  fetchBase("/config", { method: "GET" });

export const useEnvConfig = (): UseQueryResult<EnvConfig> =>
  useQuery("config", getEnvConfig, { staleTime: Infinity });
